import { defineNuxtPlugin } from '#app';

// This Nuxt plugin performs the following actions:
// 1. Creates and mounts a component in the DOM to display a loading state.
// 2. Removes the loading component after the page loading is completed.

export default defineNuxtPlugin((nuxtApp) => {
    // Check if the 'document' object and its 'body' property exist.
    if (document && document.body) {
        // Create a 'div' element to display the loading component.
        const loaderHtmlComponent = document.createElement('div');
        // Insert the HTML code for the loading component, specified in the plugin options.
        loaderHtmlComponent.innerHTML = `<!doctype html>
<html lang="en">
    <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <style>
            * {
                margin: 0;
                padding: 0;
                box-sizing: border-box;
                outline: 0;
            }

            html,
            body {
                height: 100vh;
                width: 100vh;
                overflow: hidden;
            }

            body {
                overflow: hidden;
                background-color: #180b3d;
                background-repeat: no-repeat;
                background-position: center center;
                background-attachment: fixed;
                -webkit-background-size: cover;
                background-size: cover;
            }

            .boot-loader {
                width: 100%;
                height: 100%;
                position: fixed;
                z-index: 1000;
                background: #180b3d;
            }

            .boot-loader__wrapper {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 100%;
                min-height: 100%;
                max-width: 1320px;
                margin: 0 auto;
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            .boot-loader__wrapper > * {
                flex: 0 0 50%;
                max-width: 50%;
            }

            .boot-loader__wrapper--image {
                width: 50%;
            }

            .boot-loader__wrapper--line {
                width: 100%;
                margin: 6rem 0 0;
            }

            .boot-preloader {
                width: 100%;
                height: 8px;
                border-radius: 5px;
                background-color: #fff;
                position: relative;
                overflow: hidden;
            }

            .boot-preloader--line {
                height: 100%;
                background-color: #7133d3;
                position: absolute;
                top: 0;
                left: 0;
                animation: loading 3s linear infinite;
            }

            @keyframes loading {
                0% {
                    width: 0;
                }
                100% {
                    width: 100%;
                }
            }
        </style>
    </head>
    <body>
        <div class="boot-loader">
            <div class="boot-loader__wrapper">
                <div class="boot-loader__wrapper--image">
                    <svg viewBox="0 0 835 203" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M328.636 40.4064L307.433 64.1936L327.044 90.153V92.6559H308.1L293.408 72.7908H286.23V92.6559H269.453V37.9036H286.23V57.7635H292.487L308.929 37.9036H328.626V40.4064H328.636Z"
                            fill="white"
                        />
                        <path
                            d="M353.008 37.9036V69.4485L377.375 37.9036H394.152V92.6559H377.629V61.1057L353.257 92.6559H336.48V37.9036H353.008Z"
                            fill="white"
                        />
                        <path
                            d="M421.608 37.9036V57.7635H445.726V37.9036H462.503V92.6559H445.726V72.7908H421.608V92.6559H404.83V37.9036H421.608Z"
                            fill="white"
                        />
                        <path
                            d="M486.626 90.2749C481.509 87.9654 477.541 84.6689 474.733 80.3856C471.919 76.1023 470.521 71.1526 470.521 65.5313V65.1142C470.521 59.493 471.919 54.5432 474.733 50.2548C477.541 45.9714 481.509 42.6598 486.626 40.3248C491.744 37.9847 497.67 36.8198 504.406 36.8198C511.248 36.8198 517.23 37.9847 522.348 40.3248C527.465 42.6598 531.413 45.9562 534.196 50.2141C536.978 54.4669 538.372 59.4319 538.372 65.1142V65.5313C538.372 71.2034 536.978 76.1735 534.196 80.4263C531.413 84.6842 527.465 87.9653 522.348 90.28C517.225 92.5895 511.243 93.7443 504.406 93.7443C497.67 93.7392 491.744 92.5844 486.626 90.2749ZM517.174 75.0848C519.901 73.0551 521.264 69.952 521.264 65.7806V64.9463C521.264 56.5984 515.648 52.427 504.411 52.427C498.901 52.427 494.73 53.4851 491.891 55.5962C489.048 57.7125 487.634 60.8257 487.634 64.9463V65.7806C487.634 69.952 489.022 73.0551 491.805 75.0848C494.588 77.1146 498.784 78.132 504.411 78.132C510.19 78.1269 514.448 77.1146 517.174 75.0848Z"
                            fill="white"
                        />
                        <path
                            d="M539.878 52.9257V37.9036H595.047V52.9257H575.853V92.6559H559.076V52.9257H539.878Z"
                            fill="white"
                        />
                        <path
                            d="M652.384 37.9036V52.2542H618.412V58.1807H650.715V72.2821H618.412V78.295H652.384V92.6508H601.635V37.8984H652.384V37.9036Z"
                            fill="white"
                        />
                        <path
                            d="M720.739 90.153V92.6559H704.379L700.792 83.6416H676.751L673.164 92.6559H656.804V90.153L679.503 37.9036H698.035L720.739 90.153ZM695.197 69.7843L688.767 53.8414L682.342 69.7843H695.197Z"
                            fill="white"
                        />
                        <path
                            d="M715.565 52.9257V37.9036H770.735V52.9257H751.541V92.6559H734.764V52.9257H715.565Z"
                            fill="white"
                        />
                        <path
                            d="M812.968 37.9036C819.866 37.9036 825.263 39.5416 829.16 42.8279C833.056 46.1141 835 50.6467 835 56.4307V57.265C835 63.0541 833.051 67.602 829.16 70.9137C825.263 74.2254 819.871 75.8838 812.968 75.8838H794.105V92.6609H777.328V37.9086L812.968 37.9036ZM817.892 57.265V56.4307C817.892 53.7651 816.112 52.4272 812.551 52.4272H794.105V61.3601H812.551C816.112 61.355 817.892 59.9917 817.892 57.265Z"
                            fill="white"
                        />
                        <path
                            d="M333.307 109.123V111.626L311.02 163.875H291.653L269.367 111.626V109.123H286.561L301.253 146.513L315.944 109.123H333.307Z"
                            fill="white"
                        />
                        <path
                            d="M348.995 161.495C343.877 159.19 339.914 155.889 337.101 151.605C334.293 147.322 332.889 142.372 332.889 136.751V136.334C332.889 130.718 334.293 125.763 337.101 121.48C339.914 117.191 343.877 113.885 348.995 111.545C354.118 109.21 360.044 108.045 366.774 108.045C373.622 108.045 379.599 109.21 384.716 111.545C389.834 113.885 393.787 117.176 396.569 121.434C399.352 125.692 400.741 130.657 400.741 136.334V136.751C400.741 142.423 399.352 147.393 396.569 151.651C393.787 155.909 389.834 159.19 384.716 161.5C379.594 163.809 373.616 164.964 366.774 164.964C360.044 164.959 354.118 163.804 348.995 161.495ZM379.543 146.305C382.27 144.28 383.638 141.172 383.638 137V136.166C383.638 127.818 378.017 123.647 366.779 123.647C361.27 123.647 357.099 124.705 354.26 126.821C351.421 128.937 350.002 132.051 350.002 136.166V137C350.002 141.172 351.391 144.28 354.174 146.305C356.956 148.334 361.153 149.357 366.779 149.357C372.563 149.352 376.816 148.334 379.543 146.305Z"
                            fill="white"
                        />
                        <path
                            d="M437.632 109.123C448.264 109.123 456.261 111.392 461.633 115.924C467 120.462 469.691 127.238 469.691 136.247V136.832C469.691 154.861 458.998 163.87 437.632 163.87H408.753V109.118H437.632V109.123ZM449.068 146.096C451.408 144.264 452.573 141.258 452.573 137.086V136.089C452.573 131.969 451.362 128.952 448.941 127.034C446.519 125.111 442.719 124.155 437.551 124.155H425.53V148.858H437.632C442.918 148.853 446.733 147.932 449.068 146.096Z"
                            fill="white"
                        />
                        <path d="M164.741 153.813L0.442871 201.774V0L164.741 43.8303V153.813Z" fill="#7133D3" />
                        <path
                            d="M98.5323 140.973L223.995 176.41V27.3325L98.5323 59.7169V140.973Z"
                            fill="url(#paint0_linear_7501_561)"
                        />
                        <path d="M164.741 122.212L98.5323 141.543V60.231L164.741 77.8933V122.212Z" fill="white" />
                        <defs>
                            <linearGradient
                                id="paint0_linear_7501_561"
                                x1="98.5313"
                                y1="101.873"
                                x2="223.994"
                                y2="101.873"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stop-color="#FFCE00" />
                                <stop offset="1" stop-color="#FFCE00" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
                <div class="boot-loader__wrapper--line">
                    <div class="boot-preloader">
                        <div class="boot-preloader--line"></div>
                    </div>
                </div>
            </div>
        </div>
    </body>
</html>
`;
        // Insert the loading component at the beginning of the document's body.
        document.body.insertBefore(loaderHtmlComponent, document.body.firstChild);

        function removeHTMLComponent() {
            if (loaderHtmlComponent) {
                // Remove the loading component.
                loaderHtmlComponent.remove();
            }
        }

        // Register the 'page:finish' hook to perform actions after page loading is complete.
        nuxtApp.hook('page:finish', () => {
            setTimeout(() => {
                // Remove the loading component.
                removeHTMLComponent();
            }, Number(`2000`));
        });

        // Remove element after fatal error occures
        nuxtApp.hook('app:error', () => {
            // Remove the loading component.
            removeHTMLComponent();
        });
    }
});
